import { rootReducer } from './index';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const { createBlacklistFilter } = require('redux-persist-transform-filter');

const { createMigrate } = require('redux-persist');

export const resetStore = () => undefined;

const migrations = {
  0: resetStore,
};
const autoMergeLevel2 = require('redux-persist/lib/stateReconciler/autoMergeLevel2').default;

export const createPersistedRootReducer = (key: string) =>
  persistReducer(
    {
      key,
      version: Math.max(...Object.keys(migrations).map(key => Number(key))),
      storage,
      migrate: createMigrate(migrations, { debug: true }),
      blacklist: ['extensions', 'queryString'],
      transforms: [createBlacklistFilter('stores', ['searchQuery', 'sortOrder'])],
      stateReconciler: autoMergeLevel2,
    },
    rootReducer
  );
